import { useMemo } from "react";

import { useQueryClient } from "@tanstack/react-query";

import { createTechnologyQueryClient } from "../queries/client/factory";

/**
 * React hook wrapper around technologyQueryClient.
 */
export const useTechnologyQueryClient = () => {
    const queryClient = useQueryClient();

    return useMemo(() => createTechnologyQueryClient({ queryClient }), [queryClient]);
};
